import { useMatch } from "react-router-dom-v5-compat";

import { ROUTES } from "routing/routes";

export function useIsOnCourseAssignments() {
  return useMatch(`${ROUTES.CLASSROOM.COURSE.ASSIGNMENTS.path}/*`);
}

export function useIsOnCourseAssignmentsTodo() {
  return useMatch(`${ROUTES.CLASSROOM.COURSE.ASSIGNMENTS.TODO.path}/*`);
}

export function useIsInVocabularyAssignment() {
  return useMatch(`${ROUTES.CLASSROOM.COURSE.VOCABULARY.path}/*`);
}
